import { createAction, props } from '@ngrx/store';

import { CommonMidCountry } from '@offconon/core-api';

import { CountryEntity } from './country.models';

export const initCountry = createAction('[Country Page] Init');

export const loadCountrySuccess = createAction(
  '[Country/API] Load Country Success',
  props<{ country: CountryEntity[] }>(),
);

export const loadCountryFailure = createAction(
  '[Country/API] Load Country Failure',
  props<{ error: any }>(),
);

export const fetchCountryList = createAction('[Country/API] Fetch Country List');

export const updateCountryList = createAction(
  '[Country/API] Update Country List',
  props<{ countryList: CommonMidCountry[] }>(),
);

export const updateSelectedCountry = createAction(
  '[Country/API] Update Selected Country',
  props<{ selectedCountry: CommonMidCountry }>(),
);
